import { FC } from "react";
import { FavoriteButtonFilters } from "./FavoriteButtonFilters";
import { FavoriteFiltersList } from "./FavoriteFiltersList";

interface IProps {
  reportID: any;
  breadcrumbsLength: any;
  filters: any;
}

const RegisterDocumentsFilters: FC<IProps> = ({ breadcrumbsLength, filters, reportID }) => {
  return (
    <div>
      <div className="flex gap-[10px] items-center">
        {reportID === "1" ? (
          <div className="flex gap-[10px] items-center">
            {!!breadcrumbsLength && <FavoriteButtonFilters filters={filters} />}

            <FavoriteFiltersList />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default RegisterDocumentsFilters;
